<template>
  <div class="flex items-center gap-3">
    <span class="text-xs text-gray-600 w-24">{{ label }}</span>
    <div class="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
      <div
        class="h-full rounded-full transition-all"
        :class="color"
        :style="{ width: percentage + '%' }"
      ></div>
    </div>
    <span class="text-xs text-gray-500 w-8 text-right">{{ count }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  label: string
  count: number
  total: number
  color: string
}>()

const percentage = computed(() =>
  props.total > 0 ? Math.round((props.count / props.total) * 100) : 0
)
</script>
